import type { WatchQueryFetchPolicy } from '@apollo/client';
import { useMcpPreviewForceSsr } from '@shared/context/mcpPreviewForceSsr';

type McpPreviewQueryOptions = Readonly<{
  forceSsr: boolean;
  ssr: boolean;
  fetchPolicy: WatchQueryFetchPolicy | undefined;
}>;

/** Shared Apollo options for guest widgets normally `ssr:false`; on the preview path they use `cache-first` + `ssr:true`. See MCP_PREVIEW.md#cache-first-reads. */
export const useMcpPreviewQueryOptions = (): McpPreviewQueryOptions => {
  const forceSsr = useMcpPreviewForceSsr();
  return {
    forceSsr,
    ssr: forceSsr,
    fetchPolicy: forceSsr ? 'cache-first' : undefined,
  };
};
